
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Travelagentinpune() {



  const cardData =
  {
    keyword: 'Travel Agents in Pune',
    heading: 'AB Ghule Cabs: Travel Agents in Pune',
    headingDescription: 'Looking for reliable travel agents in Pune to help plan your next trip? AB Ghule Cabs offers comprehensive travel services, providing the best travel options, itineraries, and expert advice for all your travel needs. Whether you are planning a family vacation, a business trip, or a pilgrimage, our team of professional travel agents ensures that every aspect of your journey is smooth and hassle-free.',

    top: 'Top Travel Services Offered by AB Ghule Cabs in Pune:',

    topPlaces: [
        {
            title: "Custom Travel Itineraries",
            description: "We offer personalized travel itineraries to suit your preferences, whether you're looking for a relaxing getaway, an adventurous holiday, or a spiritual pilgrimage. Our travel agents help create the perfect plan tailored to your interests."
        },
        {
            title: "Cab and Taxi Services",
            description: "Our reliable cab services ensure that your commute within Pune or to outstation destinations is comfortable and convenient. Choose from a wide range of vehicles, from compact cars to luxury taxis, for your travel needs."
        },
        {
            title: "Flight and Train Bookings",
            description: "We assist you in booking domestic and international flights, as well as train tickets, to ensure that your travel plans are seamless and stress-free. Our agents help you find the best deals and secure your tickets in advance."
        },
        {
            title: "Hotel and Accommodation Booking",
            description: "Whether you're looking for budget accommodations or luxury stays, our travel agents provide options that best suit your needs. We ensure your stay is comfortable by choosing hotels with excellent services and prime locations."
        },
        {
            title: "Tour Packages",
            description: "AB Ghule Cabs offers ready-made and customizable tour packages to popular destinations, including domestic and international trips. Our travel agents work with you to create a perfect holiday experience."
        },
        {
            title: "Group Tours and Family Holidays",
            description: "Traveling in a group or with family? We provide group tour packages that offer great value and ensure everyone has an unforgettable experience. Our agents handle all logistics, from transport to accommodation and activities."
        },
        {
            title: "Visa and Travel Documentation Assistance",
            description: "We assist with visa applications and all necessary travel documentation, ensuring you have the right paperwork for a hassle-free trip. Our experts guide you through the entire process."
        },
        {
            title: "Pilgrimage Tours",
            description: "Specializing in pilgrimage tours, we offer spiritual journeys to places like Shirdi, Pandharpur, and more. Our agents ensure that your pilgrimage is peaceful, organized, and spiritually fulfilling."
        },
        {
            title: "Corporate Travel Services",
            description: "For business professionals, we provide corporate travel services, including cab bookings, flight arrangements, hotel bookings, and more. We focus on making your business trips efficient and comfortable."
        },
        {
            title: "Adventure Travel and Outdoor Activities",
            description: "If you're an adventure enthusiast, our travel agents can organize trips for trekking, camping, and outdoor activities. Explore the best of nature and adrenaline in safe, organized tours."
        }
    ],


   services: [
    {
      "name": "Travel Agents in Pune",
      description: "AB Ghule Cabs is one of the trusted travel agents in Pune, offering reliable services for local and outstation travel. Whether you need a taxi, car rental, or tour planning, we ensure a comfortable and hassle-free experience."
    },
    {
      "name": "Travel Agency in Pune for Car",
      description: "Looking for a travel agency in Pune for car rentals? AB Ghule Cabs provides well-maintained cars for local and outstation trips, ensuring that your journey is safe and comfortable."
    },
    {
      "name": "Best Travel Agencies in Pune",
      description: "AB Ghule Cabs is among the best travel agencies in Pune. Our services include taxi bookings, car rentals, and guided tours, all at competitive prices and with a focus on customer satisfaction."
    },
    {
      "name": "Pune Best Travel Agency",
      description: "As one of Pune's best travel agencies, AB Ghule Cabs offers a wide range of travel services. From taxi services to customized tours, we cater to your travel needs, ensuring comfort, safety, and reliability."
    },
    {
      "name": "Pune Tours and Travels Agents",
      description: "AB Ghule Cabs provides expert tours and travel services in Pune, offering both local and outstation tours. We ensure a smooth and pleasant journey with well-maintained vehicles and experienced drivers."
    },
    {
      "name": "Tour Agencies in Pune",
      description: "Looking for a tour agency in Pune? AB Ghule Cabs offers tailored travel packages for individuals, families, and corporate groups, ensuring that your trip is enjoyable and stress-free."
    },
    {
      "name": "Tourist Agency in Pune",
      description: "As a leading tourist agency in Pune, AB Ghule Cabs offers personalized services for tourists visiting Pune and nearby attractions. Our experienced team helps plan and execute your trips for a memorable experience."
    },
    {
      "name": "Travel Agents in Kothrud",
      description: "AB Ghule Cabs is your trusted travel agent in Kothrud. We offer taxi services, car rentals, and guided tours, ensuring a comfortable and hassle-free journey for all your travel needs."
    },
    {
      "name": "Travel Agents in Hadapsar Pune",
      description: "For reliable travel agents in Hadapsar, Pune, choose AB Ghule Cabs. We offer professional taxi services and car rentals for both local and outstation trips, ensuring timely and safe travel."
    },
    {
      "name": "Travel Agents in Viman Nagar",
      description: "AB Ghule Cabs offers trusted travel services in Viman Nagar. Whether you're booking a taxi, renting a car, or planning a trip, our services are designed for your comfort and convenience."
    },
    {
      "name": "Travel Agents in Kharadi",
      description: "AB Ghule Cabs provides excellent travel services in Kharadi. Our taxi and car rental services ensure a smooth and enjoyable journey, with well-maintained vehicles and professional drivers."
    },
    {
      "name": "Travel Agency in Kharadi Pune",
      description: "For a reliable travel agency in Kharadi, Pune, AB Ghule Cabs offers affordable and efficient services for your travel needs, including local tours, outstation trips, and car rentals."
    },
    {
      "name": "Travel Agency in Viman Nagar Pune",
      description: "AB Ghule Cabs offers a travel agency service in Viman Nagar, Pune, specializing in taxi bookings, car rentals, and organized tours. Our services ensure comfort, reliability, and safety throughout your journey."
    },
    {
      "name": "Travel Agents in Vadgaon Sheri, Pune",
      description: "AB Ghule Cabs offers trustworthy travel agent services in Vadgaon Sheri, Pune. We provide taxis, car rentals, and organized tours to ensure you travel conveniently and comfortably."
    },
    {
      "name": "Travel Agents in Wagholi Pune",
      description: "AB Ghule Cabs provides travel services in Wagholi, Pune. We offer taxi services, car rentals, and local tours with professional drivers ensuring a smooth and safe journey for all travelers."
    },
    {
      "name": "Travel Agents in Pune Airport",
      description: "If you're looking for travel agents near Pune Airport, AB Ghule Cabs offers convenient airport taxi services, ensuring a prompt and comfortable ride to your destination in Pune or nearby."
    },
    {
      "name": "Travel Agents in Baner Aundh Pune",
      description: "AB Ghule Cabs is a reliable travel agent in Baner Aundh, Pune, offering taxi services, car rentals, and organized tours for individuals and groups. We ensure comfortable and hassle-free travel experiences."
    },
    {
      "name": "Travel Agents in Koregaon Park",
      description: "AB Ghule Cabs offers trusted travel agent services in Koregaon Park, Pune. We specialize in taxi bookings, car rentals, and travel planning, ensuring a seamless travel experience for all our clients."
    },
    {
      "name": "Travel Agents in Wanwadi Pune",
      description: "AB Ghule Cabs offers reliable travel agent services in Wanwadi, Pune. Our services include local taxis, car rentals, and tour packages, ensuring a comfortable and efficient journey."
    },
    {
      "name": "Travel Agents in Pune Contact Number",
      description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Travel Agents in Pune. We ensure a smooth and enjoyable ride for all our customers."
    }
  ],

  tableData : [
    ["- Travel Agents in Pune", "- Travel agency in pune for car"],
    ["- Best Travel Agencies in Pune", "- Pune Best Travel Agency"],
    ["- Pune Tours and Travels agents", "- Tour Agencies in Pune"],
    ["- Tourist agency in pune", "- Travel Agents in Kothrud"],
    ["- Travel Agents in Hadapsar Pune", "- Travel agents in viman nagar"],
    ["- Travel agents in kharadi", "- Travel agency in kharadi pune"],
    ["- Travel agency in viman nagar pune", "- Travel Agents in Vadgaon Sheri"],
    ["- Travel Agents in Wagholi Pune", "- Travel agents in pune airport"],
    ["- Travel agents in baner aundh pune", "- Travel agents in koregaon park"],
    ["- Travel Agents in Wanwadi Pune", ""]
  ],
  
  whychoose : [
    {
      WhyChooseheading: "Reliable and Professional Service",
      WhyChoosedescription: "At AB Ghule Travels, we offer reliable and professional travel agent services in Pune. Whether you’re planning a domestic or international trip, we provide personalized services to make your travel experience seamless and hassle-free."
    },
    {
      WhyChooseheading: "24/7 Availability",
      WhyChoosedescription: "We are available round-the-clock to assist with all your travel needs. Whether you’re looking to book a last-minute flight or need travel advice, our customer support team is always ready to help."
    },
    {
      WhyChooseheading: "Customized Travel Packages",
      WhyChoosedescription: "We offer a range of travel packages to suit different preferences and budgets. From family vacations to business trips, we tailor packages to your specific requirements, ensuring you get the best experience at competitive prices."
    },
    {
      WhyChooseheading: "Expert Travel Planning",
      WhyChoosedescription: "Our experienced team of travel agents are experts in planning trips. With in-depth knowledge of destinations, we provide insightful recommendations and handle every detail of your journey, from booking flights and hotels to organizing tours."
    },
    {
      WhyChooseheading: "Affordable and Transparent Pricing",
      WhyChoosedescription: "AB Ghule Travels offers competitive and transparent pricing for all our travel services. There are no hidden charges, and we provide the best deals to help you save while enjoying a high-quality travel experience."
    },
    {
      WhyChooseheading: "Customer Satisfaction",
      WhyChoosedescription: "Our primary focus is customer satisfaction. With numerous positive reviews and repeat clients, we pride ourselves on delivering exceptional service that exceeds expectations and ensures a memorable trip."
    },
    {
      WhyChooseheading: "Convenient Booking Process",
      WhyChoosedescription: "Booking your trip with AB Ghule Travels is easy. You can make bookings online via our website, call our customer service team, or visit our office for personalized assistance."
    }
  ]
  
  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book my trip with AB Ghule Travels?',
      answer: 'You can book your trip through our website, over the phone, or by visiting our office. Our team will help guide you through the booking process and tailor your trip according to your preferences.',
    },
    {
      id: 'FAQ2',
      question: 'Do you offer customized travel packages?',
      answer: 'Yes, we specialize in offering customized travel packages that are tailored to your needs. Whether it’s a family vacation, honeymoon, or business trip, we create packages that suit your requirements.',
    },
    {
      id: 'FAQ3',
      question: 'Can you assist with international travel bookings?',
      answer: 'Yes, we assist with both domestic and international travel bookings, including flights, accommodations, visas, and sightseeing tours, ensuring a smooth and organized travel experience.',
    },
    {
      id: 'FAQ4',
      question: 'What types of travel services do you offer?',
      answer: 'We offer a full range of travel services including flight bookings, hotel reservations, tour packages, travel insurance, and car rentals, all designed to provide a complete travel solution.',
    },
    {
      id: 'FAQ5',
      question: 'Do you offer group travel services?',
      answer: 'Yes, we specialize in group travel services. Whether it\'s for a corporate trip, family reunion, or a group of friends, we can organize comfortable and affordable group travel packages.',
    },
    {
      id: 'FAQ6',
      question: 'Are your services affordable?',
      answer: 'AB Ghule Travels offers competitive pricing on all our services, with transparent pricing and no hidden charges. We work hard to provide great value for your travel investment.',
    },
    {
      id: 'FAQ7',
      question: 'Can I modify or cancel my booking?',
      answer: 'Yes, you can modify or cancel your booking based on the terms and conditions of the specific travel package. We are happy to assist with any changes or cancellations.',
    },
    {
      id: 'FAQ8',
      question: 'Do you provide travel insurance services?',
      answer: 'Yes, we offer travel insurance services to ensure you’re covered in case of unexpected situations while traveling. Our team will guide you through the best options for your trip.',
    },
    {
      id: 'FAQ9',
      question: 'Why should I choose AB Ghule Travels over other travel agents?',
      answer: 'AB Ghule Travels stands out for its personalized customer service, expert travel planning, affordable prices, and a wide range of travel options. Our focus on customer satisfaction ensures a smooth and enjoyable travel experience.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: "Mr. Rahul Khandekar",
      feedback: "I used AB Ghule Travels for my family vacation, and it was one of the best travel experiences we’ve had. The team helped us plan everything from flights to sightseeing tours, and everything went smoothly. Highly recommended!",
      rating: 5,
    },
    {
      id: 2,
      name: "Ms. Neha Desai",
      feedback: "AB Ghule Travels took care of all our travel arrangements for a business trip to Delhi. The itinerary was well-planned, the hotels were great, and the service was excellent. I’ll definitely use them again for my future trips.",
      rating: 5,
    },
  ];
  
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Trusted Travel Agents in Pune | Best Travel Agencies</title>
  <meta name="description" content="Find the best travel agents in Pune for car rentals, tours, and travel packages. Call +91 8624029699 for bookings with AB Ghule Cabs, offering top travel services in Kothrud, Hadapsar, Viman Nagar, Kharadi, and more." />
  <meta name="keywords" content="Travel Agents in Pune, Travel Agency in Pune for Car, Best Travel Agencies in Pune, Pune Best Travel Agency, Pune Tours and Travels Agents, Tour Agencies in Pune, Tourist Agency in Pune, Travel Agents in Kothrud, Travel Agents in Hadapsar Pune, Travel Agents in Viman Nagar, Travel Agents in Kharadi, Travel Agency in Kharadi Pune, Travel Agency in Viman Nagar Pune, Travel Agents in Vadgaon Sheri, Pune, Travel Agents in Wagholi Pune, Travel Agents in Pune Airport, Travel Agents in Baner Aundh Pune, Travel Agents in Koregaon Park, Travel Agents in Wanwadi Pune" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Trusted Travel Agents in Pune | Best Travel Agencies" />
  <meta property="og:description" content="Find the best travel agents in Pune for car rentals, tours, and travel packages. Call +91 8624029699 for bookings with AB Ghule Cabs, offering top travel services in Kothrud, Hadapsar, Viman Nagar, Kharadi, and more." />
  <meta property="og:image" content="https://abghulecabs.com/images/travel-agents-pune.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/travel-agents-in-pune" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "TravelAgency",
        "name": "AB Ghule Cabs - Trusted Travel Agents in Pune",
        description: "Find the best travel agents in Pune for car rentals, tours, and travel packages. Call +91 8624029699 for bookings with AB Ghule Cabs, offering top travel services in Kothrud, Hadapsar, Viman Nagar, Kharadi, and more.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411057",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/travel-agents-in-pune",
        "logo": "https://abghulecabs.com/images/travel-agents-pune.jpg",
        "image": "https://abghulecabs.com/images/travel-agents-pune.jpg",
        "priceRange": "₹3000 - ₹15000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/travel-agents-in-pune",
          "priceCurrency": "INR",
          "price": "3000",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "reviewCount": "150"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Rajesh S"
            },
            "datePublished": "2024-10-12",
            "reviewBody": "AB Ghule Cabs provided excellent travel services. I booked a car for a family trip, and the experience was great. Highly recommended!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Neha P"
            },
            "datePublished": "2024-07-25",
            "reviewBody": "The travel services were seamless. The car was clean and the driver was polite and knowledgeable. Would definitely use their services again."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune and Surrounding Areas",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5195",
            "longitude": "73.8551"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/travel-agents-in-pune"
        },
        "keywords": "Travel Agents in Pune, Travel Agency in Pune for Car, Best Travel Agencies in Pune, Pune Best Travel Agency, Pune Tours and Travels Agents, Tour Agencies in Pune, Tourist Agency in Pune, Travel Agents in Kothrud, Travel Agents in Hadapsar Pune, Travel Agents in Viman Nagar, Travel Agents in Kharadi, Travel Agency in Kharadi Pune, Travel Agency in Viman Nagar Pune, Travel Agents in Vadgaon Sheri, Pune, Travel Agents in Wagholi Pune, Travel Agents in Pune Airport, Travel Agents in Baner Aundh Pune, Travel Agents in Koregaon Park, Travel Agents in Wanwadi Pune"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/63.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Travelagentinpune;